import * as React from 'react'

import { observer } from 'mobx-react'

interface Props {
  src: string
}

const Video = ({ src }: Props) => {
  return (
    <video controls>
      <source src={src} />
    </video>
  )
}

export default observer(Video)
